import { useContext, useState } from 'react';
import AnimatedSection from '../components/AnimatedSection';
import { ContentContext } from '../contexts/ContentContext';
import '../styles/contact.css';

const INFO_ITEMS = [
  {
    label: 'Phone',
    value: '226-220-8759',
    href: 'tel:2262208759',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4F8EF7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
      </svg>
    ),
  },
  {
    label: 'Email',
    value: 'klaivoxai@gmail.com',
    href: 'mailto:klaivoxai@gmail.com',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4F8EF7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
        <polyline points="22,6 12,13 2,6"/>
      </svg>
    ),
  },
  {
    label: 'Website',
    value: 'klaivox.com',
    href: 'https://klaivox.com',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4F8EF7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="2" y1="12" x2="22" y2="12"/>
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
      </svg>
    ),
  },
  {
    label: 'Hours',
    value: 'Monday – Friday, 9:00 AM – 6:00 PM EST',
    href: null,
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4F8EF7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <polyline points="12 6 12 12 16 14"/>
      </svg>
    ),
  },
];

const CALL_CHECKLIST = [
  'A live walkthrough of the full Klaivox platform',
  'Answers to all your questions about pricing and setup',
  'Your reseller account configured live on the call',
  'No pressure, no obligation — just a real conversation',
];

const CHECK_ICON = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4F8EF7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const CAL_DAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
const CAL_CELLS = [
  null,  null,  null,  1,     2,
  3,     4,     5,     6,     7,
  8,     9,     10,    11,    12,
  13,    14,    15,    16,    17,
  18,    19,    20,    21,    22,
  23,    24,    25,    26,    27,
  28,    29,    30,    31,    null,
];
const AVAIL = new Set([3, 8, 10, 16, 18, 21, 23, 25, 28]);
const SELECTED = 16;

const BOOKING_DETAILS = [
  {
    label: '30-minute video call',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  },
  {
    label: 'Google Meet link sent to your email',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>,
  },
  {
    label: 'No commitment required',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
  },
  {
    label: 'Mon – Fri · 9:00 AM – 6:00 PM EST',
    icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  },
];

function BookingCard({ url }) {
  return (
    <div className="booking-card">

      {/* Decorative calendar preview */}
      <div className="booking-card__cal" aria-hidden="true">
        <div className="booking-cal__glow" />
        <div className="booking-cal__nav">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          <strong>July 2026</strong>
          <span>›</span>
        </div>
        <div className="booking-cal__grid">
          {CAL_DAYS.map(d => (
            <div key={d} className="booking-cal__hdr">{d}</div>
          ))}
          {CAL_CELLS.map((d, i) => (
            <div
              key={i}
              className={`booking-cal__cell${!d ? ' booking-cal__cell--empty' : d === SELECTED ? ' booking-cal__cell--selected' : AVAIL.has(d) ? ' booking-cal__cell--avail' : ' booking-cal__cell--taken'}`}
            >
              {d || ''}
            </div>
          ))}
        </div>
        <div className="booking-cal__slot">
          <div className="booking-cal__slot-dot" />
          <div className="booking-cal__slot-info">
            <span className="booking-cal__slot-date">Thursday, July 16</span>
            <span className="booking-cal__slot-time">2:00 PM – 2:30 PM EST</span>
          </div>
          <span className="booking-cal__slot-badge">Selected</span>
        </div>
      </div>

      {/* Content */}
      <div className="booking-card__body">
        <h2 className="booking-card__title">Book Your Free 30-Min Demo</h2>
        <p className="booking-card__sub">
          Select a time that works for you. We'll walk you through the platform live and get your AI assistant configured on the same call.
        </p>

        <ul className="booking-card__details">
          {BOOKING_DETAILS.map((d, i) => (
            <li key={i}>
              <span className="booking-card__detail-icon">{d.icon}</span>
              {d.label}
            </li>
          ))}
        </ul>

        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary booking-card__cta"
        >
          Choose Your Time Slot →
        </a>

        <div className="booking-card__powered">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          Powered by Google Calendar
        </div>
      </div>

    </div>
  );
}

function ContactForm() {
  const [fields, setFields] = useState({ name: '', email: '', phone: '', message: '' });
  const [sent, setSent] = useState(false);
  const set = (k, v) => setFields(f => ({ ...f, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const body = [
      `Name: ${fields.name}`,
      `Email: ${fields.email}`,
      `Phone: ${fields.phone || 'Not provided'}`,
      '',
      fields.message,
    ].join('\n');
    window.open(
      `mailto:klaivoxai@gmail.com?subject=${encodeURIComponent(`Inquiry from ${fields.name}`)}&body=${encodeURIComponent(body)}`,
      '_blank'
    );
    setSent(true);
  };

  if (sent) {
    return (
      <div className="contact-form contact-form--sent">
        <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10"/>
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        <p>Your email client will open with your message pre-filled — just hit send. We reply within one business day.</p>
        <button onClick={() => setSent(false)} className="contact-form__retry">Send another message</button>
      </div>
    );
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit} noValidate>
      <div className="contact-form__row">
        <div className="contact-form__field">
          <label htmlFor="cf-name">Your Name</label>
          <input id="cf-name" type="text" required placeholder="Jane Smith" value={fields.name} onChange={e => set('name', e.target.value)} />
        </div>
        <div className="contact-form__field">
          <label htmlFor="cf-email">Email Address</label>
          <input id="cf-email" type="email" required placeholder="jane@yourbusiness.com" value={fields.email} onChange={e => set('email', e.target.value)} />
        </div>
      </div>
      <div className="contact-form__field">
        <label htmlFor="cf-phone">Phone <span>(optional)</span></label>
        <input id="cf-phone" type="tel" placeholder="+1 416 555 0123" value={fields.phone} onChange={e => set('phone', e.target.value)} />
      </div>
      <div className="contact-form__field">
        <label htmlFor="cf-message">How can we help?</label>
        <textarea id="cf-message" required rows={4} placeholder="Tell us about your business and what you're looking for..." value={fields.message} onChange={e => set('message', e.target.value)} />
      </div>
      <button type="submit" className="btn-primary contact-form__submit">Send Message →</button>
    </form>
  );
}

export default function Contact() {
  const { content } = useContext(ContentContext);
  const c = content.contact || {};

  const BOOKING_URL = c.bookingUrl || 'https://calendar.app.google/6wNXN6as4MAe7NpMA';

  const infoItems = [
    { label: 'Phone',   value: c.phone   || '226-220-8759',          href: `tel:${(c.phone || '226-220-8759').replace(/\D/g,'')}`, icon: INFO_ITEMS[0].icon },
    { label: 'Email',   value: c.email   || 'klaivoxai@gmail.com',   href: `mailto:${c.email || 'klaivoxai@gmail.com'}`, icon: INFO_ITEMS[1].icon },
    { label: 'Website', value: c.website || 'klaivox.com',           href: `https://${c.website || 'klaivox.com'}`,   icon: INFO_ITEMS[2].icon },
    { label: 'Hours',   value: c.hours   || 'Monday – Friday, 9:00 AM – 6:00 PM EST', href: null,                     icon: INFO_ITEMS[3].icon },
  ];

  const callChecklist = c.expectItems || CALL_CHECKLIST;

  return (
    <main>
      {/* Hero */}
      <section className="contact-hero" aria-label="Contact hero">
        <div className="contact-hero__blob contact-hero__blob--1" aria-hidden="true" />
        <div className="contact-hero__blob contact-hero__blob--2" aria-hidden="true" />
        <div className="contact-hero__content">
          <span className="section-label">Contact Us</span>
          <h1>{c.heading || "Let's Get You Set Up"}</h1>
          <p>{c.subtext || "Book a free demo and we'll walk you through the platform live — and get your account configured on the same call."}</p>
        </div>
      </section>

      {/* Main section */}
      <section className="contact-section" aria-label="Contact information and form">
        <div className="contact-section__inner">

          {/* Left — Info */}
          <AnimatedSection>
            <div className="contact-info">
              <span className="section-label">Reach Out</span>
              <h2>We're Here to Help</h2>

              <div className="contact-info__items">
                {infoItems.map((item, i) => (
                  <div className="contact-info__item" key={i}>
                    <div className="contact-info__icon">{item.icon}</div>
                    <div>
                      <div className="contact-info__label">{item.label}</div>
                      {item.href ? (
                        <a
                          href={item.href}
                          className="contact-info__value"
                          target={item.href.startsWith('http') ? '_blank' : undefined}
                          rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                        >
                          {item.value}
                        </a>
                      ) : (
                        <span className="contact-info__value">{item.value}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div>
                <p className="contact-info__checklist-title">What to expect on the call:</p>
                <ul className="contact-info__checklist" aria-label="What to expect on the demo call">
                  {callChecklist.map((item, i) => (
                    <li key={i}>{CHECK_ICON}{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </AnimatedSection>

          {/* Right — Booking */}
          <AnimatedSection delay={0.15}>
            <BookingCard url={BOOKING_URL} />
          </AnimatedSection>

        </div>
      </section>

      {/* Contact Form */}
      <section className="contact-form-section" aria-label="Send a message">
        <div className="contact-form-section__inner">
          <AnimatedSection>
            <div className="contact-form-section__header">
              <span className="section-label">Or Send a Message</span>
              <h2>Prefer to Write?</h2>
              <p>Fill out the form below and we'll get back to you within one business day.</p>
            </div>
          </AnimatedSection>
          <AnimatedSection delay={0.1}>
            <ContactForm />
          </AnimatedSection>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="cta-banner" aria-label="Call to action">
        <div className="cta-banner__blob" aria-hidden="true" />
        <AnimatedSection>
          <div className="cta-banner__inner">
            <h2>Deploy Your First AI Agent in Under 24 Hours</h2>
            <p className="cta-banner__sub">
              No monthly fees <span>·</span> 100% white-labeled <span>·</span> Hands-free deployment
            </p>
            <a href={`mailto:${c.email || 'klaivoxai@gmail.com'}`} className="btn-primary" aria-label="Email us">
              Email Us: {c.email || 'klaivoxai@gmail.com'}
            </a>
          </div>
        </AnimatedSection>
      </section>
    </main>
  );
}
